export const CM_SET_FORMAT = "CM_SET_FORMAT";
export const CM_SET_WORDS = "CM_SET_WORDS";

export const CM_SET_OWNER = "CM_SET_OWNER";
export const CM_SET_CATEGORY = "CM_SET_CATEGORY";
export const CM_SET_SOCIALS = "CM_SET_SOCIALS";

export const CM_LOAD_WORDS = "CM_LOAD_WORDS";
export const CM_ADD_WORD = "CM_ADD_WORD";
export const CM_REMOVE_WORD = "CM_REMOVE_WORD";
